import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { SidebarService } from '../../services/sidebar/sidebar.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UniqueIdService } from '../../services/unique-id/unique-id.service';
import { MatDrawer } from '@angular/material/sidenav';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';
import { UserService } from '../../services/user/user.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, AfterViewInit {
  @ViewChild('drawer') drawer!: MatDrawer;
  showFiller = false;
  sectionId: number = 0;
  childrenId: number = 0;
  defaultMenuOptions: any[] = [];
  menuOptions: any = [];
  openedMenus = new Set<string>();
  isCollapsed = false;
  tooltipMessage: string = 'Sistema de Regulação';
  id;
  userPath;
  userConf;
  urlSelected: string = '';
  editarAuxiliarRegex: any = /^\/auxiliar\/[0-9a-fA-F\-]{36}\/editar$/;
  editarPermissoesRegex: any = /^\/permissoes\/[0-9a-fA-F\-]{36}\/editar$/;
  addPermissionarioRegex: any =
    /^\/permissao\/[0-9a-fA-F\-]{36}\/permissionario$/;
  editarPermissionarioRegex: any =
    /^\/permissao\/[0-9a-fA-F\-]{36}\/permissionario\/[0-9a-fA-F\-]{36}$/;
  editarUsuarioRegex: any = /^\/usuario\/[0-9a-fA-F\-]{36}\/editar$/;
  editarEntidadeRegex: any = /^\/entidade\/[0-9a-fA-F\-]{36}\/editar$/;
  systemName: string | null;
  userName: string = '';
  userProfile: string = '';
  profile:any;
constructor(
  private sidebarService: SidebarService,
  private userService: UserService,
  private authService: AuthService,
  private sanitizer: DomSanitizer,
  private uniqueIdService: UniqueIdService,
  private router: Router
) {
  this.id = this.uniqueIdService.generateUniqueIdWithPrefix('user-registration');
  this.userPath = this.getSafeUrl('../../../assets/create-user/svgs/user.svg');
  this.userConf = this.getSafeUrl('../../../assets/create-user/svgs/user_conf.svg');
  this.systemName = localStorage.getItem('SystemName');

  this.loadUserData();

this.router.events
  .pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd) // Adicione ": event is NavigationEnd"
  )
  .subscribe((event) => { 
    this.urlSelected = event.urlAfterRedirects;
    this.updateMenuOptionsForRoute(this.urlSelected);
    if (this.urlSelected === '/home') {
      this.loadUserData();
    }
  });
}

private loadUserData(): void {
  const userId = this.authService.getUserIdFromToken();
  if (userId) {
    this.userService.getMenuUsuario(userId).subscribe((user: any) => {
      this.profile = user.profileUser;
      this.defaultMenuOptions = this.sidebarService.getMenuOptions(user);
      this.updateMenuOptionsForRoute(this.router.url);
      this.userName = user.nome;
      this.userProfile = user.profileUser.nome;
    });
  }
}
  ngAfterViewInit(): void {
    this.drawer.toggle();
  }

  ngOnInit() {}

  toggleDrawer(): void {
    this.showFiller = !this.showFiller;
    this.isCollapsed = !this.isCollapsed;
    if (!this.showFiller) {
      this.sectionId = 0;
      
    }
  }
  redirectToHome(){
    
      this.router.navigate(['home']);
  }
getMenuConfiguracao() {
  this.menuOptions = this.sidebarService.getMenuConfiuracaoOptions();
  this.router.navigate([this.sidebarService.getConfigurationWelcomeRoute()]);
}
  openSection(id: number) {
    if (this.sectionId == id) {
      this.sectionId = 0;

      this.toggleDrawerAfterSectionClick();
      return;
    }
    this.sectionId = id;
  }

  selectChildren(id: number) {
    this.childrenId = id;
    this.toggleDrawerAfterSectionClick();
  }

  toggleDrawerAfterSectionClick() {
    if (window.innerWidth < 768) {
      this.toggleDrawer();
    }
  }
  showOptions() {
    if (!this.showFiller) {
      const buttonToggle = document.getElementsByClassName(
        'menu-button'
      ) as HTMLCollection;
      const button = buttonToggle[0] as HTMLElement;
      this.sectionId = 0;
      button?.click();
    }
  }
  getSafeUrl(path: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(path);
  }

  isUrlChild(section: any): boolean {
    const urlPatterns: { [key: string]: (string | RegExp)[] } = {
      'Gestão de usuários': [
        '/criar-usuario',
        '/perfil-usuario',
        '/perfil-usuario/novo',
        this.editarUsuarioRegex,
      ],
      Entidades: ['/criar-entidade', this.editarEntidadeRegex],
      Contratos: ['/criar-contrato'],
      Cadastrando: [
        '/criar-auxiliar',
        this.editarAuxiliarRegex,
        '/criar-permissao',
        this.editarPermissoesRegex,
        this.addPermissionarioRegex,
        this.editarPermissionarioRegex,
      ],
    };

    let isChild =
      section.hasChildren && this.isUrlInHierarchy(section, this.urlSelected);

    if (urlPatterns[section.description]) {
      isChild =
        isChild ||
        urlPatterns[section.description].some((pattern) =>
          typeof pattern === 'string'
            ? pattern === this.urlSelected
            : pattern.test(this.urlSelected)
        );
    }

    return isChild;
  }

  activeStyle(option: any): boolean {
    return this.isUrlInHierarchy(option, this.urlSelected);
  }

  private isUrlInHierarchy(option: any, targetUrl: string): boolean {
    if (targetUrl === '') {
      return false;
    }

    if (option.route === targetUrl) {
      return true;
    }

    if (option.children && option.children.length > 0) {
      return option.children.some((childOption: any) =>
        this.isUrlInHierarchy(childOption, targetUrl)
      );
    }

    return false;
  }

  toggleMenu(id: string) {
    if (this.openedMenus.has(id)) {
      this.openedMenus.delete(id);
    } else {
      this.openedMenus.add(id);
    }
  }

  isMenuOpen(id: string): boolean {
    return this.openedMenus.has(id);
  }

  private updateMenuOptionsForRoute(route: string): void {
    if (this.sidebarService.isConfigurationRoute(route)) {
      this.menuOptions = this.sidebarService.getMenuConfiuracaoOptions();
      return;
    }

    this.menuOptions = this.defaultMenuOptions;
  }

  logout() {
    this.authService.logout();
  }
}
